define(function(){
  const IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
    urlRoot: "/delegate/civics-api/api",
    url: function() {
      var url = this.urlRoot;
      url = this.urlRoot+"/portal/features/"+this.id;

      return url;
    }
  })
});
